var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "course__item",
      class: {
        "course__item--vertical": _vm.vertical
      }
    },
    [
      _vm.event.image
        ? _c("div", { staticClass: "course__item-image" }, [
            _c("img", {
              staticClass: "course__item-image-element",
              attrs: {
                src: _vm.event.image,
                alt: "event image",
                loading: "lazy"
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "course__item-details" }, [
        _vm.event.title
          ? _c("h3", {
              directives: [
                {
                  name: "sanitize",
                  rawName: "v-sanitize",
                  value: _vm.event.title,
                  expression: "event.title"
                }
              ],
              staticClass: "course__item-title"
            })
          : _vm._e(),
        _vm._v(" "),
        _c("span", {
          directives: [
            {
              name: "sanitize",
              rawName: "v-sanitize",
              value: _vm.formatDate(_vm.event.date),
              expression: "formatDate(event.date)"
            }
          ],
          staticClass: "course__item-date"
        }),
        _vm._v(" "),
        _vm.showDescription && _vm.event.description
          ? _c("div", {
              directives: [
                {
                  name: "sanitize",
                  rawName: "v-sanitize",
                  value: _vm.event.description,
                  expression: "event.description"
                }
              ],
              staticClass: "course__item-description"
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "course__item-info" }, [
          _c(
            "div",
            { staticClass: "course__item-info-row" },
            [
              _c("SVGLocation", { staticClass: "course__item-info-icon" }),
              _vm._v(" "),
              _c("strong", {
                directives: [
                  {
                    name: "sanitize",
                    rawName: "v-sanitize",
                    value: _vm.formatLocation(_vm.event.location),
                    expression: "formatLocation(event.location)"
                  }
                ],
                staticClass: "course__item-info-text"
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "course__item-info-row" },
            [
              _c("SVGClock", { staticClass: "course__item-info-icon" }),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "sanitize",
                    rawName: "v-sanitize",
                    value: _vm.formatTime(_vm.event, _vm.isEvent),
                    expression: "formatTime(event, isEvent)"
                  }
                ],
                staticClass: "course__item-info-text"
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isEvent && !_vm.isBooking
            ? _c(
                "div",
                { staticClass: "course__item-info-row" },
                [
                  _c("SVGSpeechBubble", {
                    staticClass: "course__item-info-icon"
                  }),
                  _vm._v(" "),
                  _c("span", {
                    directives: [
                      {
                        name: "sanitize",
                        rawName: "v-sanitize",
                        value: _vm.$t("course.language." + _vm.event.locale),
                        expression: "$t(`course.language.${event.locale}`)"
                      }
                    ],
                    staticClass: "course__item-info-text"
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isEvent && !_vm.isBooking
            ? _c(
                "div",
                { staticClass: "course__item-info-row" },
                [
                  _c("SVGUsers", { staticClass: "course__item-info-icon" }),
                  _vm._v(" "),
                  _c("span", {
                    directives: [
                      {
                        name: "sanitize",
                        rawName: "v-sanitize",
                        value: _vm.$tc(
                          "course.freePlacesCount",
                          _vm.event.free,
                          { count: _vm.event.free }
                        ),
                        expression:
                          "$tc('course.freePlacesCount', event.free, { count: event.free })"
                      }
                    ],
                    staticClass: "course__item-info-text"
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "course__item-info-row" },
            [
              _c("SVGMoney", { staticClass: "course__item-info-icon" }),
              _vm._v(" "),
              _vm.event.price
                ? _c("strong", {
                    directives: [
                      {
                        name: "sanitize",
                        rawName: "v-sanitize",
                        value: _vm.$options.filters.fwgpricecent(
                          _vm.event.price,
                          "html"
                        ),
                        expression:
                          "$options.filters.fwgpricecent(event.price, 'html')"
                      }
                    ],
                    staticClass: "course__item-info-text"
                  })
                : _c("strong", {
                    directives: [
                      {
                        name: "sanitize",
                        rawName: "v-sanitize",
                        value: _vm.$t("course.free"),
                        expression: "$t('course.free')"
                      }
                    ],
                    staticClass: "course__item-info-text"
                  })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm.showDetailsButton || _vm.buttonText
          ? _c(
              "div",
              { staticClass: "course__item-buttons" },
              [
                _vm.showDetailsButton
                  ? _c("Button", {
                      attrs: {
                        text: _vm.$t("course.detailsButton"),
                        level: "secondary",
                        type: "button",
                        small: "",
                        block: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit("course:info", _vm.event)
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.buttonText
                  ? _c("Button", {
                      attrs: {
                        text: _vm.buttonText,
                        level: "primary",
                        type: "button",
                        small: "",
                        block: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit("course:select", _vm.event)
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }